import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Upload, message } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../Common/APIConstants";
import axios from "axios";
import { ImageSlice } from "../../../../../Utils/UserSlice";

const Settings = () => {
  const mode = useSelector((state) => state.darkMode);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const { isdarkMode } = mode;
  const dispatch= useDispatch();

  const [logo, setLogo] = useState(null);
  const [background, setBackground] = useState(null);
  const [excelImage, setExcelImage] = useState(null);
    const getImages = () => {
      // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
      const url = `${APIConstants.ELECTRICAL_GET_LOGO_IMAGE}`;
      //console.log(url);
  
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => { 
        // console.log(res);
        if (res) {
          setLogo(res?.logo?`data:image/png;base64,${res?.logo}`:null);
          setBackground(res?.backGroundImage?`data:image/png;base64,${res?.backGroundImage}`:null);
          setExcelImage(res?.excelImage?`data:image/png;base64,${res?.excelImage}`:null);
          dispatch(ImageSlice(res))
        }
      });
    };
    useEffect(()=>{
      getImages()
    },[])
  const handleAddLogo = async () => {
  if (!logo) {
    message.error("Please upload a logo image first.");
    return;
  }
  await uploadSingleImage("Logo", logo);
};

const handleAddBackground = async () => {
  if (!background) {
    message.error("Please upload a background image first.");
    return;
  }
  console.log(background)
  await uploadSingleImage("BackGroundImage", background);
};

const handleAddExcelImage = async () => {
  if (!excelImage) {
    message.error("Please upload an Excel image first.");
    return;
  }
  await uploadSingleImage("excelImage", excelImage);
};

const handleBeforeUpload = (file, type) => {
  const isImage = file.type.startsWith('image/');
  if (!isImage) {
    message.error("You can only upload image files!");
    return Upload.LIST_IGNORE;
  }

  let isValidSize = false;
  let maxSize = 0;

  if (type === "logo") {
    maxSize = 2; // 2 MB
  } else if (type === "background") {
    maxSize = 10; // 10 MB
  } else if (type === "excelImage") {
    maxSize = 12; // 12 MB
  }

  isValidSize = file.size / 1024 / 1024 < maxSize;

  if (!isValidSize) {
    message.error(`Image must be smaller than ${maxSize}MB!`);
    return Upload.LIST_IGNORE;
  }

  // If validation passes, call your existing handler
  handleUpload(file, type);
  return false; // Prevent default upload behavior
};


  const handleUpload = (file, type) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const base64Image = e.target.result; // This is the base64 image data URL
      if (type === "logo") {
        console.log("Logo image in Base64:", base64Image);
        setLogo(base64Image);
      } else if (type === "background") {
        console.log("Background image in Base64:", base64Image);
        setBackground(base64Image);
      } else if (type === "excelImage") {
        console.log("Excel image in Base64:", base64Image);
        setExcelImage(base64Image);
      }
    };

    reader.readAsDataURL(file); // Convert file to base64
    return false; // Prevent auto upload behavior of Ant Design Upload
  };
    const handleNotification = (msg, type) => {
      message.open({
        content: `${msg}`,
        type: type,
      });
    };

  const uploadSingleImage = async (type, imageBase64) => {
  try {
    const formData = new FormData();
    const blob = base64ToBlob(imageBase64);

    // Add image type field
    formData.append("InputImageType", type);

    // Add the image file
    formData.append("InputImage", blob, `${type}.png`);

      const url = `${APIConstants.ELECTRICAL_INSERT_LOGO_IMAGE}`;

    const response = await axios.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // console.log(`${type} uploaded successfully:`, response.data);
    // handleNotification(response.data,'success')
    message.success(`${type.charAt(0).toUpperCase() + type.slice(1)} uploaded successfully!`);
    return response.data;
  } catch (error) {
    console.error(`Failed to upload ${type}:`, error.response || error);
    message.error(`Failed to upload ${type}!`);
    throw error;
  }
};

  const uploadSingleImages = async (title, image) => {
    console.log(title);
    console.log(image);
    // uploadImages(logo, background, excelImage);
    try {
      const body = {
        InputImageType:title? title:"",
        InputImage:image?image:"",
        // InputImage:image?image?.split(",")[1]:"",
      };
      console.log("Payload:", body);

      const url = `${APIConstants.ELECTRICAL_INSERT_LOGO_IMAGE}`;

      makeRequest({
        type: APIConstants.PUT,
        url: url,
        body,
      }).then((res) => {
        if (res) {
          console.log("Response:", res);
        }
      });

      message.success("Settings saved successfully!");
    } catch (error) {
      console.error(error);
      message.error("Failed to save settings!");
    }
  };


  function base64ToBlob(base64Data) {
    const parts = base64Data.split(",");
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const byteString = atob(parts[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type: mime });
  }
  console.log(background)
  console.log(excelImage)

  return (
    <div
      className={`relative  p-2 ${isdarkMode ? "bg-transparent" : "bg-white"}`}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h4
          className={`text-left text-[24px] font-semibold ${
            isdarkMode ? "darkfont" : "whitemode"
          }`}
        >
          Settings
        </h4>
      </div>

      <Card
        className={`${isdarkMode ? "bg-transparent" : "bg-white"} flex flex-col gap-6 min-h-screen`}
      >
        <Card
          className={`${isdarkMode ? "bg-transparent" : "bg-white"}  mb-5 `}
          title={
            <div className="flex justify-between  mr-5">
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Add a logo
              </span>
              <Upload
                beforeUpload={(file) => handleBeforeUpload(file, "logo")}
                showUploadList={false}
                accept="image/*"
              >
                <Button icon={<UploadOutlined />}>Upload Logo</Button>
              </Upload>
            </div>
          }
          extra={
            <Button type="primary" onClick={handleAddLogo}>
              Add +
            </Button>
          }
        >
          <div className="flex justify-center items-center">
          {logo ? (
            <div>
              <div className="w-[80vw] h-40  flex items-center justify-center overflow-hidden">
                <img
                  src={logo}
                  alt="Logo"
                  className="object-contain h-[680px] w-[100px]"
                />
              </div>
            </div>
          ):"Preview of Image"}
          </div>
        </Card>
        <Card
          className={`${isdarkMode ? "bg-transparent" : "bg-white"}  mb-5 `}
          title={
            <div className="flex justify-between  mr-5">
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Add Background Image
              </span>
              <Upload
                beforeUpload={(file) => handleBeforeUpload(file, "background")}
                showUploadList={false}
                accept="image/*" // ✅ Accept only images
              >
                <Button icon={<UploadOutlined />}>Upload Background</Button>
              </Upload>
            </div>
          }
          extra={
            <Button type="primary" onClick={handleAddBackground}>
              Add +
            </Button>
          }
        >
          <div className="flex justify-center items-center">
          {background ? (
            <div>
              <div className="w-[80vw] h-40  flex items-center justify-center overflow-hidden">
                <img
                  src={background}
                  alt="excel"
                  className="object-contain h-[680px] w-[100px]"
                />
              </div>
            </div>
          ):"Preview of Image"}

          </div>
        </Card>
        <Card
          className={`${isdarkMode ? "bg-transparent" : "bg-white"}  mb-5 `}
          title={
            <div className="flex justify-between  mr-5">
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Add Excel Image
              </span>
              <Upload
                beforeUpload={(file) => handleBeforeUpload(file, "excelImage")}
                showUploadList={false}
                accept="image/*" // ✅ Accept only images
              >
                <Button icon={<UploadOutlined />}>Upload Excel Image</Button>
              </Upload>
            </div>
          }
          extra={
            <Button type="primary" onClick={handleAddExcelImage}>
              Add +
            </Button>
          }
        >
          <div className="flex justify-center items-center">
          {excelImage ? (
            <div>
              <div className="w-[80vw] h-40  flex items-center justify-center overflow-hidden">
                <img
                  src={excelImage}
                  alt="background"
                  className="object-contain h-[680px] w-[100px]"
                />
              </div>
            </div>
          ):"Preview of Image"}
          </div>
        </Card>
      </Card>
    </div>
  );
};

export default Settings;
